var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstrellas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 224,
    viewBox: "0 0 228 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4944_54217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.46 193.748C119.805 193.689 121.146 193.611 122.479 193.518L120.031 149.408L135.235 192.036C136.551 191.824 137.86 191.594 139.159 191.345L127.867 148.017L151.473 188.394C152.728 188.03 153.978 187.656 155.213 187.258L135.334 145.732L166.788 182.91C167.957 182.405 169.109 181.882 170.249 181.347L142.251 142.613L180.816 175.71C181.87 175.075 182.903 174.428 183.924 173.768L148.459 138.725L193.245 166.976C194.159 166.229 195.057 165.473 195.93 164.701L153.814 134.165L203.795 156.916C204.546 156.075 205.275 155.219 205.985 154.354L158.19 129.039L212.197 145.741C212.771 144.823 213.321 143.896 213.85 142.962L161.478 123.464L218.249 133.72C218.631 132.749 218.991 131.772 219.328 130.785L163.61 117.575L221.8 121.133C221.977 120.13 222.137 119.122 222.268 118.107L164.533 111.505L222.78 108.277C222.756 107.259 222.715 106.242 222.641 105.233L164.221 105.401L221.193 95.4531C220.968 94.4509 220.718 93.4548 220.443 92.465L162.688 99.4062L217.048 82.9527C216.621 81.9909 216.166 81.0384 215.695 80.0922L159.973 93.654L210.401 71.0903C209.786 70.1908 209.146 69.3005 208.49 68.4197L156.127 88.2878L201.441 60.1369C200.654 59.3182 199.85 58.5121 199.022 57.7152L151.252 83.4258L190.391 50.3382C189.448 49.6223 188.484 48.9219 187.508 48.234L145.454 79.1895L177.495 41.9402C176.42 41.3426 175.334 40.7543 174.231 40.1847L138.872 75.6753L163.061 35.1235C161.88 34.6566 160.687 34.2084 159.481 33.7726L131.656 72.9642L147.418 30.0685C146.159 29.7479 144.888 29.446 143.608 29.1565L123.988 71.1246L130.934 26.9061C129.626 26.7349 128.31 26.5824 126.985 26.4454L116.033 70.1908L114.007 25.6984C113.343 25.689 112.679 25.6797 112.01 25.6797C111.342 25.6797 110.677 25.689 110.013 25.6984L107.988 70.1908L97.0352 26.4485C95.7108 26.5855 94.3945 26.738 93.0865 26.9092L100.033 71.1246L80.4119 29.1565C79.1325 29.446 77.8614 29.7448 76.6025 30.0685L92.3607 72.9673L64.5349 33.7757C63.3293 34.2115 62.1361 34.6597 60.9551 35.1266L85.1438 75.6784L49.7896 40.1878C48.6865 40.7574 47.5999 41.3426 46.5256 41.9434L78.5667 79.1926L36.5122 48.2372C35.5363 48.9282 34.5727 49.6254 33.6296 50.3413L72.7686 83.4289L24.9981 57.7183C24.1698 58.5121 23.3661 59.3213 22.5788 60.14L67.8931 88.2909L15.526 68.4166C14.8699 69.2974 14.2302 70.1877 13.6152 71.0872L64.0428 93.6509L8.32146 80.0922C7.8499 81.0384 7.39475 81.9909 6.9683 82.9527L61.3201 99.4L3.56901 92.4619C3.29428 93.4517 3.04825 94.4478 2.81862 95.45L59.7906 105.398L1.37526 105.233C1.30555 106.242 1.26044 107.259 1.23584 108.277L59.4831 111.505L1.7484 118.104C1.87961 119.119 2.03953 120.127 2.21585 121.129L60.4057 117.572L4.69254 130.782C5.02468 131.769 5.38962 132.746 5.77096 133.717L62.542 123.461L10.1667 142.962C10.6956 143.899 11.2492 144.823 11.8192 145.741L65.8265 129.039L18.0355 154.354C18.749 155.216 19.4747 156.072 20.2251 156.916L70.2058 134.165L28.0898 164.704C28.9673 165.476 29.8653 166.232 30.7757 166.979L75.561 138.729L40.096 173.768C41.117 174.431 42.1504 175.078 43.2042 175.71L81.7691 142.61L53.7711 181.344C54.911 181.879 56.0633 182.402 57.2319 182.907L88.6866 145.729L68.8075 187.255C70.0418 187.653 71.2883 188.027 72.5472 188.391L96.1536 148.014L84.8609 191.342C86.1608 191.591 87.4688 191.821 88.7851 192.033L103.99 149.405L101.542 193.514C102.874 193.608 104.215 193.686 105.56 193.745L112.01 149.875L118.46 193.748Z",
    fill: "url(#paint0_radial_4944_54217)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4944_54217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8646 26.2192L51.2271 28.2532L55.1556 28.1517L53.1216 31.5142L53.2231 35.4426L49.8606 33.4087L45.9321 33.5101L47.9661 30.1477L47.8646 26.2192Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5997 28.161L83.6558 30.0321L86.3964 30.4983L84.5253 32.5543L84.0591 35.295L82.003 33.4239L79.2624 32.9576L81.1335 30.9016L81.5997 28.161Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7764 0.476562L101.662 3.92437L105.11 5.81004L101.662 7.69571L99.7764 11.1435L97.8907 7.69571L94.4429 5.81004L97.8907 3.92437L99.7764 0.476562Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.675 23.4531L129.561 26.9009L133.009 28.7866L129.561 30.6723L127.675 34.1201L125.79 30.6723L122.342 28.7866L125.79 26.9009L127.675 23.4531Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.281 18.5377L153.412 21.5578L155.151 24.0302L152.131 24.1608L149.659 25.9002L149.528 22.8802L147.789 20.4078L150.809 20.2771L153.281 18.5377Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.444 26.1471L172.744 28.2806L176.674 28.2964L174.54 31.5966L174.524 35.5264L171.224 33.3929L167.294 33.3771L169.428 30.0769L169.444 26.1471Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1092 63.0927L24.3358 62.8246L26.9079 60.8581L27.176 64.0847L29.1426 66.6568L25.9159 66.9249L23.3438 68.8914L23.0757 65.6648L21.1092 63.0927Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2627 42.7344L65.1483 46.1822L68.5962 48.0679L65.1483 49.9535L63.2627 53.4013L61.377 49.9535L57.9292 48.0679L61.377 46.1822L63.2627 42.7344Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6714 41.356L98.5281 44.0547L102.389 44.7857L99.6905 47.6424L98.9595 51.5035L96.1028 48.8049L92.2417 48.0738L94.9403 45.2172L95.6714 41.356Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.162 50.5312L132.395 52.7856L134.649 54.0185L132.395 55.2515L131.162 57.5058L129.929 55.2515L127.675 54.0185L129.929 52.7856L131.162 50.5312Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7724 162.856L52.6147 160.142L53.5438 156.324L56.2575 159.166L60.0759 160.095L57.2336 162.809L56.3046 166.627L53.5908 163.785L49.7724 162.856Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.848 136.342L153.706 134.568L154.314 132.071L156.088 133.93L158.585 134.537L156.726 136.312L156.119 138.808L154.345 136.95L151.848 136.342Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.834 36.8367L152.805 40.7664L154.9 44.0911L150.97 44.0614L147.645 46.1565L147.675 42.2268L145.58 38.9021L149.509 38.9318L152.834 36.8367Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.862 48.2948L189.659 51.0549L193.503 51.8697L190.743 54.667L189.928 58.5114L187.131 55.7512L183.287 54.9364L186.047 52.1391L186.862 48.2948Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.867 101.42L38.2492 105.331L40.6811 108.418L36.7699 108.8L33.683 111.232L33.3008 107.321L30.8689 104.234L34.7801 103.852L37.867 101.42Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4842 139.168L29.6823 142.426L33.2905 143.983L30.033 146.181L28.4761 149.789L26.278 146.531L22.6698 144.974L25.9273 142.776L27.4842 139.168Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4553 125.745L44.8181 127.094L47.5351 126.955L46.1863 129.317L46.3253 132.034L43.9626 130.685L41.2455 130.824L42.5944 128.462L42.4553 125.745Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.319 151.909L164.682 153.258L167.399 153.119L166.05 155.481L166.189 158.198L163.826 156.85L161.109 156.989L162.458 154.626L162.319 151.909Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.686 139.581L190.052 143.493L192.472 146.59L188.559 146.956L185.462 149.376L185.096 145.463L182.677 142.366L186.589 142L189.686 139.581Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.814 81.7155L183.333 84.1524L185.927 85.3847L183.49 86.9039L182.258 89.4979L180.738 87.0609L178.144 85.8287L180.581 84.3094L181.814 81.7155Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4723 153.329L83.5392 151.414L80.8787 150.845L82.7931 148.912L83.3621 146.252L85.2952 148.166L87.9556 148.735L86.0412 150.668L85.4723 153.329Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3027 74.0988L75.9615 70.2246L74.4261 66.6072L78.3003 67.266L81.9177 65.7306L81.2589 69.6048L82.7943 73.2222L78.9201 72.5634L75.3027 74.0988Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7025 101.309L63.8657 98.5618L61.679 96.7002L64.4262 95.8634L66.2878 93.6767L67.1246 96.4239L69.3112 98.2855L66.5641 99.1223L64.7025 101.309Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8875 133.649L65.3105 131.755L63.8029 130.471L65.697 129.894L66.9805 128.387L67.5574 130.281L69.0651 131.564L67.171 132.141L65.8875 133.649Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.561 80.93L156.984 79.036L155.477 77.7524L157.371 77.1755L158.654 75.6678L159.231 77.5619L160.739 78.8455L158.845 79.4224L157.561 80.93Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.565 81.6957L211.988 79.8016L210.481 78.518L212.375 77.9411L213.658 76.4335L214.235 78.3276L215.743 79.6111L213.849 80.188L212.565 81.6957Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.158 102.388L193.849 105.252L197.66 106.212L194.796 108.902L193.836 112.713L191.145 109.849L187.334 108.889L190.198 106.199L191.158 102.388Z",
    fill: "#FFFBBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4944_54217",
    x: 0.756719,
    y: 25.2006,
    width: 222.503,
    height: 169.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.239561,
    result: "effect1_foregroundBlur_4944_54217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4944_54217",
    x: 19.1929,
    y: 0.476562,
    width: 198.466,
    height: 169.981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.91648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.958242
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4944_54217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4944_54217",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4944_54217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.008 109.714) rotate(90) scale(84.0341 110.772)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrellas);
export default __webpack_public_path__ + "static/media/estrellas.764c5c6c472d1dda9f2043c2bf33dfe6.svg";
export { ForwardRef as ReactComponent };